import { Component, Input, Inject } from '@angular/core';

import { SideEffect } from "../../../../common/models/flow.dto";
import { SideEffectData, SIDE_EFFECT_DATA_TOKEN } from "./models/types";

@Component({
    selector: 'side-effect-hold',
    templateUrl: './side-effect-hold.component.html',
    standalone: false
})
export class SideEffectHoldComponent {
    _selectedSideEffect: SideEffect;
    _seConfiguration: any;

    multipliers = [
        { id: undefined, text: 'Select (days, months, years)' },
        { id: "days", text: 'Days' },
        { id: "months", text: 'Months' },
        { id: "years", text: 'Years' },
    ];

    set seConfiguration(value: any) {
        this._seConfiguration = value;
    }

    get seConfiguration(): any {
        if (this._seConfiguration == null || this._seConfiguration === undefined) 
            return {};
         else 
            return this._seConfiguration;
    }

    constructor(@Inject(SIDE_EFFECT_DATA_TOKEN) public data: SideEffectData) {
        this.seConfiguration = data.configuration;
    }
}